module.exports = __webpack_public_path__ + "img/principal.16004326.jpg";